<template>
  <b-card header="Lockgroup for locations">
    <div class="card">
      <!-- loop begin -->
      <b-row>
      <div class="col-sm-6 col-md-2" v-for="i in lockgroups" :key="i.id" style="margin:10px;">
        <div class="card" style="height:100%;">
          <div class="card-body">

            <div class="h1 text-muted text-right mb-4">
              <i class="icon-layers"></i>
            </div>
            <div class="h4 mb-0">{{i.totalLocks}}
              <small class="text-muted text-uppercase font-weight-bold" style="font-size:9px;" v-if="i.totalLocks > 1">
                Keys
              </small>
              <small class="text-muted text-uppercase font-weight-bold" style="font-size:9px;" v-if="i.totalLocks < 2">
                Key
              </small>
            </div>
            <div class="progress progress-xs mt-3 mb-0">
              <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted text-uppercase font-weight-bold" style="position:absolute; bottom:20px;"><i class="icon-location-pin"></i> {{i.location.name}}</small><br/>
            <small class="text-muted text-uppercase font-weight-bold" style="position:absolute; bottom:0;"><i class="icon-layers"></i> {{i.name}}</small><br/>
          </div>
        </div>
      </div>
      </b-row>
      <!-- loop end -->
    </div>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_LIST_LOCKGROUP = BASE + '/api/lockgroups/list'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId')
  }
  let res = await postdata(API_LIST_LOCKGROUP, parameters)
  return res.lockGroups
}

export default {
  name: 'lock-group-for-location',
  props: ['locationName', 'locationId', 'nextItem'],
  data: () => {
    return {
      lockgroups: []
    }
  },
  mounted () {
    if (localStorage.getItem('token')) {
      getData().then(response => {
        this.$data.lockgroups = response
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LockGroupForLocation.vue